import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ICase } from '../../interfaces/case.interface';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { UnitsService } from 'src/app/core/services/units.service';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { UserService } from 'src/app/core/services/user.service';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { ICaseFile } from '../../interfaces/case-file.interface';
import { CasesService } from 'src/app/core/services/cases.service';
import { add } from 'date-fns';
import { FilesService } from 'src/app/core/services/files.service';

interface UserData {
  nombre: string;
  cargo: string;
}

interface VictimData {
  nombre: string;
  cedula: string;
  telefono: string;
  direccion: string;
}

interface CaseManagementData {
  coordinador: string;
  especialista: string;
}

@Component({
  selector: 'app-create-bt-case',
  templateUrl: './create-bt-case.component.html',
  styleUrls: ['./create-bt-case.component.scss'],
})
export class CreateBtCaseComponent implements OnInit {
  caseForm: FormGroup;
  showUserFields = false;
  showAmountField = false;
  showVictimFields = false;
  private useMockData = true;
  isLoading = false;
  files: ICaseFile[] = [];
  // 📌 JSON centralizado
  private mockData = {
    fechas: {
      fechaEvento: '2023-01-01',
      fechaCreacion: '2023-01-02',
      fechaAsignacion: '2023-01-03',
      fechaFinalizacion: '2023-01-04',
    },
    origen: 'Área de Reclamos',
    naturaleza: 'Robo o Hurto de Instrumentos Financieros',
    naturalezaOtro: '',
    elaboradoPor: {
      nombreCompleto: this.userService.currentUser.fullname,
      cargo: this.userService.currentUser.role.name,
    },
    montoAfectado: '150000',
    instrumento: {
      numero: '1234567890',
      referencia: 'REF-2025-001',
      datosInstrumento: '111',
    },
    victima: {
      nombre: 'Juan Pérez',
      cedula: 'V-12345678',
      telefono: '0414-1234567',
      direccion: 'Av. Principal, Caracas',
    },
    resumen: 'Descripción breve del caso ficticio para pruebas.',
    recaudos: '' /*['Copia de cédula', 'Estado de cuenta']*/,
    sinRecaudos: false,
    recaudosPendientes: '' /*['Acta policial']*/,
    gestionCaso: {
      coordinador: 'María López',
      especialista: 'Pedro Sánchez',
    },
  };

  naturalezaOptions = [
    'Robo o Hurto de Instrumentos Financieros',
    'Robo o Hurto de Bien(es)',
    'Cambio',
    'Acceso no Autorizado',
    'Presunto Fraude por TX no reconocidas (P2P, C2P, Transferencias mismo Banco y Otros Bancos)',
    'Débitos No reconocidos con TDC',
    'Débitos No reconocidos con TDD',
    'Débitos No reconocidos con TPG',
    'Conflicto de Intereses asociados a hechos de Corrupción',
    'Usurpación de Identidad',
    'Apropiación Indebida',
    'Falsificación de Documento o Firma',
    'Sabotaje y adulteración de Sistemas',
    'Uso Indebido de tecnología de adquirencia (POS, VPOS, Prontopago, Kiosko Virtual)',
    'Falta a las Políticas de Confidencialidad',
    'Transgresiones al Código de Ética Institucional',
    'Presunto Lavado de Activos',
    'Modificación de Datos Sensibles del Cliente',
    'Otros',
  ];
  userData: UserData | null = null;
  victimData: VictimData | null = null;
  caseAmount: string | null = null;
  caseManagement: CaseManagementData | null = null;

  caseType: ICaseType | null = null;
  users: IUser[] = [];
  filesRecaudos: any[] = [];
  filesPendientes: any[] = [];

  constructor(
    private fb: FormBuilder,
    private unitsService: UnitsService,
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      unit: IUnit;

      case?: ICase;
      edit?: boolean;
    },
    private readonly dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<CreateBtCaseComponent>,
    private readonly casesService: CasesService,
    private readonly filesService: FilesService
  ) {
    this.caseForm = this.fb.group({
      fechaEvento: ['', Validators.required],
      // fechaCreacion: ['', Validators.required],
      // fechaAsignacion: ['', Validators.required],
      // fechaFinalizacion: ['', Validators.required],
      origen: ['', Validators.required],
      naturaleza: ['', Validators.required],
      naturalezaOtro: [''],
      elaboradoPor: this.fb.group({
        nombreCompleto: ['', Validators.required],
        cargo: ['', Validators.required],
      }),
      montoAfectado: ['', Validators.required],
      instrumento: this.fb.group({
        numero: ['', Validators.required],
        datosInstrumento: ['', Validators.required],
        referencia: ['', Validators.required],
      }),
      victima: this.fb.group({
        nombre: ['', Validators.required],
        cedula: ['', Validators.required],
        telefono: ['', Validators.required],
        direccion: ['', Validators.required],
      }),
      resumen: ['', Validators.required],
      recaudos: this.fb.array([]),
      sinRecaudos: [false],
      recaudosPendientes: this.fb.array([]),
      gestionCaso: this.fb.group({
        coordinador: [''],
        especialista: [''],
      }),
    });
  }

  ngOnInit(): void {
    this.getCaseTypes();
    if (!this.userData) this.showUserFields = true;
    if (!this.caseAmount) this.showAmountField = true;
    if (!this.victimData) this.showVictimFields = true;
    this.loadData();
    if (this.userService.currentUser.role.name === 'Soporte') {
      this.caseForm.get('origen')?.setValue('Soporte y reclamo');
      this.caseForm.get('origen')?.disable();
      // this.caseForm.controls.origen.updateValueAndValidity();
    }
  }
  getCaseTypes() {
    this.unitsService.getTypeCases(this.data.unit._id).subscribe({
      next: (caseTypes) => {
        this.caseType = caseTypes[0];
        if (this.caseType) {
          this.findUser();
        }
      },
    });
  }

  async findUser() {
    const roles = this.caseType.role;
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    this.users = users;
  }

  private loadData() {
    if (this.data.edit && this.data.case) {
      // Cargar los datos en el form desde additionalInformation
      this.caseForm.patchValue(this.data.case.additionalInformation);

      // Normalizamos a array
      const recaudos = Array.isArray(
        this.data.case.additionalInformation.recaudos
      )
        ? this.data.case.additionalInformation.recaudos
        : [];

      const recaudosPendientes = Array.isArray(
        this.data.case.additionalInformation.recaudosPendientes
      )
        ? this.data.case.additionalInformation.recaudosPendientes
        : [];

      // ➡️ Solución: Llenar recaudos correctamente con un FormGroup
      recaudos.forEach((rec: any) => {
        // Cambiamos el tipo a 'any' para manejar el objeto
        // Creamos un FormGroup con los datos del objeto, incluyendo 'editing'
        const recaudoGroup = this.fb.group({
          recaudo: [rec.recaudo],
          file: [rec.file],
          editing: [false], // Establecemos 'editing' en false al cargar
        });
        this.recaudos.push(recaudoGroup);
      });

      // ➡️ Solución: Llenar recaudos pendientes correctamente con un FormGroup
      recaudosPendientes.forEach((pend: any) => {
        // Cambiamos el tipo a 'any'
        const pendienteGroup = this.fb.group({
          recaudo: [pend.recaudo],
          file: [pend.file],
          editing: [false],
        });
        this.pendientes.push(pendienteGroup);
      });
    } else {
      // 🚀 Si no es edición, usar mock data o session
      let dataToUse: any;
      if (this.useMockData) dataToUse = this.mockData;
      else dataToUse = JSON.parse(sessionStorage.getItem('caseData') || '{}');

      this.caseForm.patchValue({
        ...dataToUse.fechas,
        origen: dataToUse.origen,
        naturaleza: dataToUse.naturaleza,
        naturalezaOtro: dataToUse.naturalezaOtro,
        elaboradoPor: dataToUse.elaboradoPor,
        montoAfectado: dataToUse.montoAfectado,
        instrumento: dataToUse.instrumento,
        victima: dataToUse.victima,
        resumen: dataToUse.resumen,
        sinRecaudos: dataToUse.sinRecaudos,
        gestionCaso: dataToUse.gestionCaso,
      });

      // Normalizamos
      const recaudos = Array.isArray(dataToUse.recaudos)
        ? dataToUse.recaudos
        : [];
      const recaudosPendientes = Array.isArray(dataToUse.recaudosPendientes)
        ? dataToUse.recaudosPendientes
        : [];

      // Llenar recaudos
      recaudos.forEach((rec: string) => {
        this.recaudos.push(this.fb.control(rec, Validators.required));
      });

      // Llenar recaudos pendientes
      recaudosPendientes.forEach((pend: string) => {
        this.pendientes.push(this.fb.control(pend, Validators.required));
      });
    }
  }
  get recaudos(): FormArray {
    return this.caseForm.get('recaudos') as FormArray;
  }
  recaudoFormControl(index: number): FormControl {
    return this.recaudos.at(index).get('recaudo') as FormControl;
  }
  get pendientes(): FormArray {
    return this.caseForm.get('recaudosPendientes') as FormArray;
  }
  recaudosPendientes = [];
  // addRecaudo() {
  //   (this.caseForm.get('recaudos') as FormArray).push(
  //     this.fb.control([{ recaudo: null, file: null }])
  //   );
  //   this.filesRecaudos.push({ recaudo: null, file: null });
  //   console.log('addRecaudo', this.filesRecaudos, this.caseForm);
  // }
  addRecaudo(): void {
    const recaudoGroup = this.fb.group({
      recaudo: [null],
      file: [null],
      editing: [true],
    });
    this.recaudos.push(recaudoGroup);
  }

  toggleRecaudoMode(index: number): void {
    //editar valor del recaudo
    const recaudoControl = this.recaudos.at(index) as FormGroup;

    const currentEditingStatus = recaudoControl.get('editing')!.value;
    recaudoControl.get('editing')!.setValue(!currentEditingStatus);
  }
  removeRecaudo(i: number) {
    (this.caseForm.get('recaudos') as FormArray).removeAt(i);
    // this.filesRecaudos.splice(i, 1);
  }

  addPendiente() {
    (this.caseForm.get('recaudosPendientes') as FormArray).push(
      this.fb.control(null)
    );
    // this.filesPendientes.push(undefined);
  }

  removePendiente(i: number) {
    (this.caseForm.get('recaudosPendientes') as FormArray).removeAt(i);
    // this.filesPendientes.splice(i, 1);
  }
  actualizarValidacionOtros() {
    if (this.caseForm.value.naturaleza == 'Otros') {
      this.caseForm.controls.naturalezaOtro.setValidators([
        Validators.required,
      ]);
    } else {
      this.caseForm.controls.naturalezaOtro.clearValidators();
    }
    this.caseForm.controls.naturalezaOtro.updateValueAndValidity();
  }

  submit() {
    if (this.caseForm.value.naturaleza != 'Otros') {
      this.caseForm.removeControl('naturalezaOtro');
    }

    const fd = new FormData();
    // this.filesRecaudos.forEach((rec: string) => {
    //   this.recaudos.push(this.fb.control(rec));
    // });

    // this.filesPendientes.forEach((pend: string) => {
    //   this.pendientes.push(this.fb.control(pend));
    // });

    // this.filesRecaudos.forEach((f, i) => {
    //   if (f) fd.append('recaudos', f, f.name); // o `recaudos[${i}]`
    // });
    // this.filesPendientes.forEach((f, i) => {
    //   if (f) fd.append('pendientes', f, f.name);
    // });
    const formValue = this.caseForm.getRawValue();

    const data = {
      additionalInformation: formValue,
      files: this.filesRecaudos,
      caseType: this.caseType._id,
      description: '',
    };
    this.isLoading = true;
    if (this.data.edit) {
      // ✅ MODO UPDATE
      this.casesService.updateCaseCSA(this.data.case._id, data).subscribe({
        next: (caseUpdated: any) => {
          this.isLoading = false;
          this.alert('Caso actualizado con éxito!');
          this.dialogRef.close(caseUpdated);
        },
        error: (err) => {
          this.alert(err.error);
          this.isLoading = false;
        },
      });
    } else {
      this.casesService.createCaseToCAECAI(data).subscribe({
        next: (caseCreated: any) => {
          console.log(caseCreated);

          this.isLoading = false;
          this.alert('Caso creado con éxito!');
          caseCreated.additionalInformation = this.caseForm.value;
          if (typeof caseCreated.caseType.unit == 'object') {
            caseCreated.caseType.unit;
          }

          if (
            (this.userService.currentUser.role.createCases &&
              this.userService.currentUser.role.editCases) ||
            caseCreated.assigned?._id == this.userService.currentUser._id
          ) {
            this.casesService.caseCreated.next(caseCreated);
          }
          this.dialogRef.close();
        },
        error: (err) => {
          this.alert(err.error);
          this.isLoading = false;
        },
      });
    }
  }
  formatStepLabel(campo: string): string {
    return campo.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  alert(title: string) {
    this.dialog.open(SuccessComponent, {
      data: { title },
    });
  }
  closeModal() {
    this.dialogRef.close();
  }
  onFileSelected(event: Event, index: number, tipo: 'recaudos' | 'pendientes') {
    const input = event.target as HTMLInputElement;

    const file: File =
      input.files && input.files.length ? input.files[0] : undefined;

    const formData = new FormData();
    formData.append('file', file);
    this.filesService.upload(formData).subscribe({
      next: (url) => {
        const newFile = {
          url,
          name: file.name,
          creator: this.userService.currentUser._id,
        };

        if (tipo === 'recaudos') {
          // this.filesRecaudos[index] = newFile;

          // (this.caseForm.get('recaudos') as FormArray).removeAt(index);
          // this.recaudos.push(this.fb.control(newFile));
          const recaudosArray = this.caseForm.get('recaudos') as FormArray;
          (recaudosArray.at(index) as FormGroup).patchValue({
            file: newFile,
          });
          this.filesRecaudos.push(newFile);
        } else {
          this.filesPendientes[index] = newFile;
          (this.caseForm.get('recaudosPendientes') as FormArray).removeAt(
            index
          );
          this.pendientes.push(this.fb.control(newFile));
        }
      },
    });
  }
}
